import React from 'react';
import { useSelector } from 'react-redux';

// import ActionCard from 'components/Common/Cards/ActionCard';
import { getReferralLinkState } from 'selectors/getReferralLink';
import { copyToClipboard } from 'utils/copyToClipboard';
import { ReactComponent as CopyIcon } from 'images/copy-icon.svg';

import styles from './ReferralSection.module.scss';

const REFERRAL_TERMS_URL = 'https://www.planneryapp.com/referral-terms';

const ReferralSection: React.FC = () => {
  const { referralLink } = useSelector(getReferralLinkState);

  if (!referralLink) return null;

  const handleCopyLink = () => {
    copyToClipboard(referralLink);
    analytics.track('Dashboard Referral Copy Link Clicked');
  };

  return (
    <div className={styles.referralSection}>
      <p className={styles.title}>Share Plannery and earn $5 for every friend who signs up.</p>

      <p className={styles.description}>
        Help your healthcare friends and colleagues achieve their financial goals. For every person who signs up{' '}
        <strong>you get $5 and they get $5</strong>. Terms apply.
      </p>

      <button type="button" className={styles.copyLink} onClick={handleCopyLink}>
        <span className={styles.linkText}>{referralLink}</span>
        <CopyIcon className={styles.copyIcon} aria-hidden />
      </button>

      <p className={styles.termsText}>
        By sharing this link you agree to abide by the{' '}
        <a href={REFERRAL_TERMS_URL} target="_blank" rel="noreferrer">
          terms and conditions
        </a>{' '}
        of this program
      </p>
    </div>
  );
};

export default ReferralSection;
